import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-actualizacion-masiva-precios-fallas',
  templateUrl: './actualizacion-masiva-precios-fallas.component.html',
  styleUrls: ['./actualizacion-masiva-precios-fallas.component.css']
})
export class ActualizacionMasivaPreciosFallasComponent implements OnInit {

  constructor(private toast: ToastrService,private activeModal: NgbActiveModal, private service: UserService) { }

  fallas = [];
  parseandoArchivo = false;
  files = [];

  actualizaciones = [];

  ngOnInit() {
    console.log(this.fallas);
    
  }

  decline(){
    this.activeModal.dismiss();
  }

  fileChanged(event){
    if(!this.parseandoArchivo){
      for (let index = 0; index < event.length; index++) {
        const element = event[index];
        if(element.name.endsWith(".xls") || element.name.endsWith(".xlsx") || element.name.endsWith(".csv")){
          this.parseandoArchivo = true;
          this.files.push(element.name)
          this.parseDocument(element);
        }
        else{
          this.toast.error("Error: Archivo incompatible.",'');
        }
      }  
    }
    else{
      this.toast.error("Error: Otro archivo se encuentra procesando...",'');
    }
  }

  errors = [];
  arrayBuffer : any;

  parseDocument(file){
    this.errors = [];
    this.actualizaciones = [];
    let fileReader = new FileReader();
        fileReader.onload = (e) => {
              this.arrayBuffer = fileReader.result;
              var data = new Uint8Array(this.arrayBuffer);
              var arr = new Array();
              for(var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
              var bstr = arr.join("");
              var workbook = XLSX.read(bstr, {type:"binary"});
              var first_sheet_name = workbook.SheetNames[0];
              var worksheet = workbook.Sheets[first_sheet_name];
              
              var rows = XLSX.utils.sheet_to_json(worksheet,{header:1});
              for(var i = 0; i != rows.length; ++i){
                let el = { codigo: worksheet["A" + (i+1)].w, precio_nuevo: rows[i][1], errors: []};
                // let el = { codigo: rows[i][0], precio_nuevo: rows[i][1], errors: []};
                if(el.codigo.length<1) el.errors.push("Código de falla inválido");

                // valido que la segunda columna sea un numero
                let precio = parseFloat(el.precio_nuevo);
                if(isNaN(precio)) el.errors.push("Precio inválido");


                // busco que el identificador de la falla exista entre las fallas disponibles
                let falla_index = this.fallas.findIndex(x=> x.identificador == el.codigo);
                if(falla_index<0) el.errors.push("Código de falla no encontrado");

                // busco que esta actualizacion no este repetida.
                let actualizacion_index = this.actualizaciones.findIndex(x=> x.codigo == el.codigo);
                if(actualizacion_index>=0) el.errors.push("La actualización para el código " + el.codigo + " está repetida");

                this.actualizaciones.push(el);
              }
              this.parseandoArchivo = false;
            }
        fileReader.readAsArrayBuffer(file);
  }


  accept(){
    let body = this.actualizaciones.filter(x=> x.errors.length==0);
    this.service.postFallasPrecioMasiva(body).subscribe(d=>{
      this.toast.success("Actualización exitosa");
      this.activeModal.close({});
    }, er=>{
      this.toast.error("ERROR");
    })
    
  }
}
